import { ServiceData } from '../service';
import db from '../index';
import { entityServiceFactory } from '../entityServiceFactory';

export interface DocumentationsServiceData extends ServiceData {}
const { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain } =
  entityServiceFactory<DocumentationsServiceData>(
    db,
    'documentationsService'
  );

export { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain };
